import React from "react"
import {Link} from "react-router-dom"
import styles from "../stylee/navBarDrawerModel.module.css"

const NavBarDrawerModel=(prop)=>{


return(
    <div onClick={()=>prop.setMobileMenu(false)}   className={prop.mobileMenu ?styles.back:""}>
    <div className={prop.mobileMenu ? styles.drawerContainer_open : styles.drawerContainer}>
        <div className={styles.drawerContent}>
            <div className={prop.mobileMenu ? styles.navbar_menu:styles.navRight}>
                    <div> <Link to="/"  className={styles.linkTag} > <h3>Home</h3></Link> </div>
                    <hr/>
                    <div> <Link to="/order" className={styles.linkTag}  > <h3>Order</h3></Link></div>
                    <hr/>
                    <div> <Link to="/login" className={styles.linkTag}  >  <h3>Login</h3></Link>  </div>
                    <hr/>
                    <div> <Link to="/signup" className={styles.linkTag}  >  <h3>SignUp</h3></Link>  </div>
                    <hr/>
                    <div> <Link to="/support"  className={styles.linkTag}  >  <h3>Contact Us</h3> </Link> </div>
                    <hr/>
            </div>
        </div>
        
    </div>  
     </div>
)

}

export default NavBarDrawerModel